export const CROSS_JOIN_NUDGE_PROJECT_GATE = 'cjn_project_pages_gate';
export const CROSS_JOIN_NUDGE_PROJECT_EXPERIMENT = 'cjn_project_pages_on_userid';
